interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}

export const Card = ({ children, className = '', hover = false }: CardProps) => {
  return (
    <div
      className={`
        bg-white p-6 rounded-xl shadow-sm border border-gray-200
        ${hover ? 'hover:shadow-md transition-shadow ' : ''}
        professional-hover-shadow
        ${className}
      `}
    >
      {children}
    </div>
  );
};
export default Card;
